export const PLANO_TITULO = 'Plano'

export const CONTINUE_TITULO = 'Continue na TAG'

export const CONTINUE_DESCRICAO = 'Para continuar no clube, complete o fluxo com seus dados de endereço e meio de pagamento desejado.'

export const REATIVAR_TITULO = 'Reative sua assinatura e volte a viver experiências literárias com a gente.'

export const REATIVAR_DESCRICAO = 'Reativar assinatura'

export const RENOVAR_PLANO_TITULO = 'Renovar plano'

export const RENOVAR_PLANO_DESCRICAO = 'Seu plano anual está chegando ao fim, renove e ganhe um brinde exclusivo!'

export const SOLICITOU_CANCELAMENTO_STATUS = 'Solicitou Cancelamento'

export const AGUARDANDO_CANCELAMENTO_STATUS = 'Aguardando Cancelamento'

export const ASSINE_PLANO_ANUAL_TITULO = 'Assine o plano anual'

export const ASSINE_PLANO_ANUAL_TEXTO = 'Assine o plano anual e ganhe + de 10% de desconto e um presente exclusivo!'

export const DESFAZER_CANCELAMENTO_TEXTO = 'Deseja desfazer o cancelamento? Clique no botão abaixo para desfazer o cancelamento da sua assinatura.'

export const DESFAZER_CANCELAMENTO_TITULO = 'Desfazer cancelamento'
